/**
 * O que a leitura tirou de um documento (`TP-057`, desenho do Breno: "Tipo e campos lidos"). Primeiro o tipo que o
 * agente 1 leu, para quem confere saber se o erro foi da leitura ou do gestor; depois os campos. A regra mapeia por
 * rótulo e o agente 1 confirma, corrige e acrescenta; quando os dois discordam, vale a IA. Os campos ficam fechados por
 * padrão: a linha do item continua curta, e quem quer conferir abre.
 */

import Button from '@mui/material/Button';
import { useState } from 'react';

import { ROTULO_DO_TIPO_LIDO, type DocumentoDoCaso } from './tipos';

export function MetadadosDoDocumento({ documento }: { documento: DocumentoDoCaso | null }): React.JSX.Element | null {
  const [aberto, setAberto] = useState(false);
  // Sem leitura concluída não há o que mostrar: na fila, a leitura anterior não responde pelo arquivo.
  if (documento?.leitura !== 'concluida') return null;

  const { metadados, tipoLido } = documento;
  const tipo = tipoLido === null ? 'tipo não reconhecido' : (ROTULO_DO_TIPO_LIDO[tipoLido] ?? tipoLido);

  return (
    <div className="mt-1">
      <p className="m-0 text-[var(--tinta-2)]">Lido como: {tipo}</p>
      {metadados.length > 0 && (
        <Button
          size="small"
          variant="text"
          aria-expanded={aberto}
          onClick={() => {
            setAberto((v) => !v);
          }}
          sx={{ px: 0.5, minWidth: 0 }}
        >
          {aberto ? 'Esconder o que foi lido' : `O que foi lido (${String(metadados.length)})`}
        </Button>
      )}
      {aberto && metadados.length > 0 && (
        <dl className="m-0 mt-1 grid grid-cols-[minmax(8rem,max-content)_1fr] gap-x-4 gap-y-1 rounded border border-solid border-[var(--fio)] bg-[var(--chao-2)] px-3 py-2 text-[0.8125rem]">
          {metadados.map((m) => (
            <div key={m.chave} className="contents">
              <dt className="text-[var(--tinta-2)]">{m.rotulo}</dt>
              <dd className="m-0 min-w-0 break-words text-[var(--tinta)]">
                {m.valor}
                {m.origem === 'agente' && (
                  <span className="ml-2 text-[0.75rem] text-[var(--tinta-2)]">lido pela IA</span>
                )}
              </dd>
            </div>
          ))}
        </dl>
      )}
    </div>
  );
}
